import * as React from 'react';

import {captureException, withScope} from '@sentry/browser';

type Props = {
  fallback: React.ReactElement;
  children: React.ReactNode;
};

type State = {
  error: Error | null;
  eventId: string | null;
};

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = {error: null, eventId: null};

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({error});
    withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key as keyof React.ErrorInfo]);
      });
      // Note: this is will not match in Sentry when React is in dev mode, see this github issue for details: https://github.com/getsentry/sentry-javascript/issues/4534#issuecomment-1100642605
      const eventId = captureException(error);
      this.setState({eventId});
    });
  }

  render() {
    const {error, eventId} = this.state;
    const {children, fallback} = this.props;

    if (error === null) {
      return children;
    }

    return React.cloneElement(fallback, {
      sentryEventId: eventId,
    });
  }
}
